import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";

const app = getApp();
// =============================== BASE  ===============================  //

export const REF = {
  NAME: "bailiff",
  COLLECTIONS: {
    BAILIFF: "bailiff",
    DIALOG: "dialog",
    DIALOG_EDITED: "dialogEdited",
    JOB: "job",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    bailiff: collection(firestore, REF.COLLECTIONS.BAILIFF),
    dialog: collection(firestore, REF.COLLECTIONS.DIALOG),
    dialogEdited: collection(firestore, REF.COLLECTIONS.DIALOG_EDITED),
    //
    job: collection(firestore, REF.COLLECTIONS.JOB),
  };
  return CREF;
};
